import { ChangeDetectorRef, Component } from '@angular/core';
import { KeyValues5, KeyValueSet, LocalService, UpadatePurchaseEntryDetailFor } from 'src/service/local.service';
import { PurchaseEntryService } from 'src/service/purchase-entry.service';

@Component({
  selector: 'app-purchase-entry-histories',
  templateUrl: './purchase-entry-histories.component.html',
  styleUrl: './purchase-entry-histories.component.scss'
})
export class PurchaseEntryHistoriesComponent {
  purchaseEntryId: string = ''; upadatePurchaseEntryDetailFors: KeyValueSet[] = []; purchaseEntryStatuses: KeyValueSet[] = [];
  items: KeyValues5[] = [];
  maxBodyHeight = 0;

  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private purchaseEntryService: PurchaseEntryService) { }

  ngOnInit(): void {
    this.onLoad();
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    this.purchaseEntryService.getPurchaseEntryHistories(this.purchaseEntryId).subscribe(result => {
      this.items = result;
      this.onUpdateText();
    });
  }

  onUpdateText() {
    this.items.forEach(item => {
      switch (parseInt(item.v1)) {
        case UpadatePurchaseEntryDetailFor.PurchaseEntryStatus: {
          let purchaseEntryStatuse = this.purchaseEntryStatuses.find(x => x.key == item.v2);
          if (purchaseEntryStatuse) {
            item.v2 = purchaseEntryStatuse.value;
          }

          purchaseEntryStatuse = this.purchaseEntryStatuses.find(x => x.key == item.v3);
          if (purchaseEntryStatuse) {
            item.v3 = purchaseEntryStatuse.value;
          }
        } break;
        case UpadatePurchaseEntryDetailFor.Quantity:
        case UpadatePurchaseEntryDetailFor.Price: {
          if (item.v2 && item.v2 != '-') {
            item.v2 = parseFloat(item.v2).toFixed(2);
          }
          if (item.v3 && item.v3 != '-') {
            item.v3 = parseFloat(item.v3).toFixed(2);
          }
        } break;
      }

      const upadatePurchaseEntryDetailFor = this.upadatePurchaseEntryDetailFors.find(x => x.key == item.v1);
      if (upadatePurchaseEntryDetailFor) {
        item.v1 = upadatePurchaseEntryDetailFor.value;
      }
    });
  }
}
